export const title = 'deadrop';

export const description = 'e2e encrypted secret sharing';

export const themeColors = {
  primary: '#1971c2',
  secondary: '#1a1b1e',
};

export const MAX_MDX_CONTENT_WIDTH = '800px';
